/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M12 0C5.3726 0 0 5.3726 0 12s5.3726 12 12 12l.0493-.0001.0257.0001c.0272 0 .0544-.0003.0815-.001C18.7118 23.9152 24 18.5752 24 12 24 5.4248 18.7118.0848 12.1565.001A3.3198 3.3198 0 0 0 12.075 0l-.0257.0001L12 0ZM8.6687 2.0394c-2.4469.818-4.4924 2.5124-5.764 4.7106h3.7515c.4494-1.9043 1.1414-3.5313 2.0125-4.7105ZM1.5 12c0-1.3212.244-2.5854.6894-3.75h4.1727C6.175 9.432 6.075 10.6932 6.075 12s.0999 2.5679.2871 3.75H2.1894C1.744 14.5854 1.5 13.3212 1.5 12Zm1.4047 5.25c1.2716 2.1982 3.3171 3.8926 5.764 4.7105-.871-1.1792-1.563-2.8062-2.0125-4.7105H2.9047Zm5.3008 0c.8079 3.1364 2.291 5.2307 3.8479 5.2499l.0725-.0006c1.5461-.0449 3.0158-2.1325 3.8187-5.2493H8.2055Zm9.2883 0c-.4407 1.8673-1.1146 3.4679-1.9619 4.6412 2.358-.8421 4.3267-2.5034 5.5634-4.6412h-3.6015Zm4.3168-1.5h-4.0227c.1872-1.1821.2871-2.4432.2871-3.75s-.0999-2.568-.2871-3.75h4.0227c.4454 1.1646.6894 2.4288.6894 3.75 0 1.3212-.244 2.5854-.6894 3.75Zm-5.5464 0H7.8858c-.1994-1.1618-.3108-2.4252-.3108-3.75 0-1.3248.1114-2.5882.3108-3.75h8.3784c.1994 1.1618.3108 2.4252.3108 3.75 0 1.3248-.1114 2.5882-.3108 3.75Zm1.2296-9h3.6015c-1.2367-2.1378-3.2054-3.7991-5.5634-4.6412.8473 1.1733 1.5212 2.774 1.9619 4.6412Zm-5.4404-5.2499c-1.5569.0192-3.04 2.1135-3.848 5.2499h7.7392c-.8029-3.1168-2.2726-5.2044-3.8187-5.2493l-.0725-.0006Z"
    clipRule="evenodd"
  />,
  'World'
);
